import $ from 'jquery';
import "bootstrap";
import Toast from "bootstrap/js/dist/toast"
import Tooltip from "bootstrap/js/dist/tooltip"
import  "./scss/skins/usersense.scss";




function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

//var grid = getCookie('sidemenu-grid');
//var hidden = getCookie('sidemenu-hidden');
var text = getCookie('sidemenu-text');
/*
if (grid == '0') {
  $('#sidebar').attr('data-grid','0');
  $('#sidebar-icons').attr('data-grid','0');
  $('.sidebar-grid').attr('data-grid','0');
  $('.sidebar-text2').attr('data-grid','0');
  setCookie('sidemenu-grid','0',365);
  $('.sidebar-grid').removeClass('fa-list');
  $('.sidebar-grid').addClass('fa-grid');
}
else {
  $('#sidebar').attr('data-grid','1');
  $('#sidebar-icons').attr('data-grid','1');
  $('.sidebar-grid').attr('data-grid','1');
  $('.sidebar-text2').attr('data-grid','1');
  setCookie('sidemenu-grid','1',365);
  $('.sidebar-grid').removeClass('fa-grid');
  $('.sidebar-grid').addClass('fa-list');
  
}
*/

/*
if (hidden == '1') {
  $("#sidebar").attr('data-hidden','1');
  $("#sidebar-icons").attr('data-hidden','1');
  $("#topbar-eye").attr('data-hidden','1');
  $('.sidebar-hide').attr('data-hidden','1');
  setCookie('sidemenu-hidden','1',365);
}
else {
  $("#sidebar").attr('data-hidden','0');
  $("#sidebar-icons").attr('data-hidden','0');
  $("#topbar-eye").attr('data-hidden','0');
  $('.sidebar-hide').attr('data-hidden','0');
  setCookie('sidemenu-hidden','0',365);
}
*/


if (text == '0') {
  $(".sidebar-text").attr('data-text','0');  
  $(".sidebar-text2").attr('data-text','0');  
  setCookie('sidemenu-text','0',365);
  $('.sidebar-text2').removeClass('fa-text-slash');
  $('.sidebar-text2').addClass('fa-text');  
  $("#sidebar-icons").attr('data-text','0');
  $("#sidebar-logo").attr('data-text','0');
}
else {
  $(".sidebar-text").attr('data-text','1');  
  $(".sidebar-text2").attr('data-text','1');  
  setCookie('sidemenu-text','1',365);
  $('.sidebar-text2').removeClass('fa-text');
  $('.sidebar-text2').addClass('fa-text-slash');  
  $("#sidebar-icons").attr('data-text','1');
  $("#sidebar-logo").attr('data-text','1');
}

/*
$(".sidebar-grid").on("click",function() {
  var grid = $(this).attr('data-grid');
  if (grid == '1') {
    $("#sidebar-icons").attr('data-grid','0');
    $("#sidebar").attr('data-grid','0');
    $(".sidebar-grid").attr('data-grid','0');  
    $('.sidebar-text2').attr('data-grid','0'); 
    setCookie('sidemenu-grid','0',365);
    $('.sidebar-grid').removeClass('fa-list');
    $('.sidebar-grid').addClass('fa-grid');  
  }
  else {
    $("#sidebar-icons").attr('data-grid','1');
    $("#sidebar").attr('data-grid','1');
    $(".sidebar-grid").attr('data-grid','1');   
    $('.sidebar-text2').attr('data-grid','1');
    setCookie('sidemenu-grid','1',365);
    $('.sidebar-grid').removeClass('fa-grid');
    $('.sidebar-grid').addClass('fa-list');
  }
})
*/

$(".sidebar-text2").on("click",function() {  

  var text = $(this).attr('data-text');
  if (text == '1') {
    $(".sidebar-text").attr('data-text','0'); 
    $(".sidebar-text2").attr('data-text','0');
    setCookie('sidemenu-text','0',365);
    $('.sidebar-text2').removeClass('fa-text-slash');
    $('.sidebar-text2').addClass('fa-text');  
    $("#sidebar-icons").attr('data-text','0');
    $("#sidebar-logo").attr('data-text','0');
  }
  else {
    $(".sidebar-text").attr('data-text','1');  
    $(".sidebar-text2").attr('data-text','1');  
    setCookie('sidemenu-text','1',365);
    $('.sidebar-text2').removeClass('fa-text');
    $('.sidebar-text2').addClass('fa-text-slash');  
    $("#sidebar-icons").attr('data-text','1');
    $("#sidebar-logo").attr('data-text','1');
   }
})

/*

$(".sidebar-hide").on("click",function() {
  var hidden = $(this).attr('data-hidden');
  if (hidden == '1') {
    $("#sidebar").attr('data-hidden','0');
    $("#sidebar-icons").attr('data-hidden','0');
    $("#topbar-eye").attr('data-hidden','0');
    $('.sidebar-hide').attr('data-hidden','0');
    setCookie('sidemenu-hidden','0',365);
  }
  else {
    $("#sidebar").attr('data-hidden','1');
    $("#sidebar-icons").attr('data-hidden','1');
    $("#topbar-eye").attr('data-hidden','1');
    $('.sidebar-hide').attr('data-hidden','1');
    setCookie('sidemenu-hidden','1',365);
  }
})
*/

$("#sidebar-collapse").on("click",function() {
    $("#sidebar").toggleClass("active");
})



var toastElList = [].slice.call(document.querySelectorAll('.toast'))
var toastList = toastElList.map(function (toastEl) {    
  return new Toast(toastEl, {}).show();
});

window.showToastr = function(type,title,message) {
  	console.log(type);
  	console.log(title);
  	console.log(message);
    if (type != "") {
      var bg = "bg-danger";
      if (type == "info") {
          bg = "bg-success";
      }
      var test = `
        <div class="toast toast2" role="alert" aria-live="assertive" aria-atomic="true">
          <div class="toast-header ${bg} text-white">
            <span class="fal fa-info-circle usersense-icon pe-4"></span>
            <strong class="me-auto">${title}</strong>
              <span class="fal fa-times text-white" data-bs-dismiss="toast" aria-label="Close"></span>
            </div>
            <div class="toast-body">
              ${message}
            </div>`
      $(".toast-container").append(test);
      var toastElList = [].slice.call(document.querySelectorAll('.toast2'))
      var toastList = toastElList.map(function (toastEl) {    
        new Toast(toastEl, {}).show();
      });
      $('.toast2').removeClass('toast2');
    }
  };

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
   return new Tooltip(tooltipTriggerEl,{
     boundary: 'window'
   });
 });  